import * as React from 'react';
import { Select, Input } from 'antd';
import I18N from 'src/services/I18NService';
import { IMallMedicineSpecification, IMallPharmacyDetail, IMallWesMedicineSpecification, MedicineUnitLight } from 'src/entity/MallEntity';
import { EnumMedicineCategory } from 'src/constants/enum';
import { EnumOrderType } from 'src/constants/Order';

const { Option } = Select;


/** 零售单位/中成药服用单位/批发单位 */
// const fullUnitList: string[] = ['μg', 'mg', 'mL', 'L', 'g', '片', '瓶', '盒', '支', '丸', '粒', '袋', '张', '个', '贴', '箱'];

interface IMedicineSpecificationProps {
  fullUnitList: MedicineUnitLight[],
  onChange?: (value: Partial<IMallWesMedicineSpecification> | undefined) => void;
  value?: IMallWesMedicineSpecification;
}

interface IMedicineSpecificationState {
  equivalent: string | undefined;
}

class WesternMedicineSpecification extends React.Component<IMedicineSpecificationProps, IMedicineSpecificationState> {
  constructor(props: IMedicineSpecificationProps) {
    super(props);
    let equivalent = '';
    if (!!props.value && props.value.equivalent !== undefined && props.value.equivalent !== null) {
      equivalent = props.value.equivalent.toString();
    }
    this.state = {
      equivalent,
    };
  }

  /**
   * 规格改变时触发
   *
   * @memberof WesternMedicineSpecification
   */
  equivalentChange = (e: any) => {
    try {
      let equivalent = e.target.value as string;
      equivalent = equivalent.replace(/。/g, '.');
      equivalent = equivalent.replace(/[^0-9.]/gi, '');
      if (parseFloat(equivalent) > 9999) {
        equivalent = '9999';
      }
      if (parseFloat(equivalent) < 1) {
        equivalent = '1';
      }
      const numArr = equivalent.split('.');
      if (numArr.length > 2) {
        return;
      }

      if (numArr.length > 1) {
        if (equivalent.endsWith('.')) {
          equivalent = `${equivalent}0`;
          if (isNaN(parseFloat(equivalent))) {
            return;
          }
          this.setState({
            equivalent: e.target.value,
          });
          return;
        } else {
          equivalent = `${numArr[0]}.${numArr[1].substr(0, 2)}`;
        }
      }

      if (numArr[0].trim() !== '' && isNaN(parseFloat(equivalent))) {
        return;
      }

      this.setState({
        equivalent,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 失去焦点时触发
   *
   * @memberof WesternMedicineSpecification
   */
  equivalentBlur = () => {
    this.triggerChange({ equivalent: Number(this.state.equivalent), });
  };


  /**
   * 零售单位改变时触发
   *
   * @memberof WesternMedicineSpecification
   */
  retailUnitChange = (retailUnit: string) => {
    this.triggerChange({ retail_unit: retailUnit });
  };

  /**
   * 批发单位改变时触发
   * @memberof WesternMedicineSpecification
   */
  wholesaleUnitChange = (wholesaleUnit: string) => {
    this.triggerChange({ wholesale_unit: wholesaleUnit });
  };

  /**
   * 数据改变时触发
   *
   * @memberof WesternMedicineSpecification
   */
  triggerChange = (changedValue: Partial<IMallWesMedicineSpecification>) => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };



  /**
   * 零售/批发单位选择项
   *
   * @memberof WesternMedicineSpecification
   */
  unitOptions = () => {
    const result: JSX.Element[] = [];
    const { fullUnitList } = this.props
    for (const item of fullUnitList || []) {
      result.push(
        <Option key={item.id} value={item.name}>
          {item.name}
        </Option>
      );
    }
    return result;
  };

  render() {
    const { value } = this.props;
    const retailUnit = !!value ? value.retail_unit : undefined;
    const wholesaleUnit = !!value ? value.wholesale_unit : undefined;

    return (
      <span>
        <Input
          value={this.state.equivalent}
          onChange={this.equivalentChange}
          onBlur={this.equivalentBlur}
          placeholder={`${I18N.get('common_input')}${I18N.get('med_cpm_equivalent')}`}
          style={{ width: '30%' }}
        />

        <span>
          <Select value={retailUnit} style={{ width: '30%' }} onChange={this.retailUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_retail_unit')}`}>
            {this.unitOptions()}
          </Select>
          <span style={{ width: '10%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>/</span>
          <Select value={wholesaleUnit} style={{ width: '30%' }} onChange={this.wholesaleUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_wholesale_unit')}`}>
            {this.unitOptions()}
          </Select>
        </span>

      </span>
    );
  }
}

export default WesternMedicineSpecification;


// WEBPACK FOOTER //
// ./src/components/views/Mall/WesternMedicineSpecification.tsx